export var ComplexTypeEnum;
(function (ComplexTypeEnum) {
    ComplexTypeEnum["object"] = "Object";
    ComplexTypeEnum["function"] = "Function";
    ComplexTypeEnum["array"] = "Array";
})(ComplexTypeEnum = ComplexTypeEnum || (ComplexTypeEnum = {}));
//# sourceMappingURL=complex-type-enum.js.map